import { Box, Chip, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import { type InvitationDto } from '../../../../models/peerToPeer/Invitations'
import { styles } from './InviteeList.styles'

interface Props {
  invitees: InvitationDto[]
  onResend: (invitationId: number) => void
  onRevoke: (invitationId: number) => void
}

export const InviteeTable = ({ invitees, onResend, onRevoke }: Props): JSX.Element => (
  <Box sx={{ overflowX: 'auto' }}>
    <Table size='small' data-testid='p2pInviteeTable'>
      <TableHead>
        <TableRow>
          <TableCell sx={styles.headCell}>Email</TableCell>
          <TableCell sx={styles.headCell}>Status</TableCell>
          <TableCell sx={styles.headCell} align='right'>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {invitees.map(invitee => (
          <TableRow key={invitee.id} data-testid={`p2pInvitee-${invitee.id}`}>
            <TableCell>{invitee.email}</TableCell>
            <TableCell>
              <Chip size='small' label={invitee.status} color={invitee.status === 'Accepted' ? 'success' : 'default'} variant='outlined' />
            </TableCell>
            <TableCell align='right'>
              {invitee.status !== 'Accepted' &&
                <IconButton
                  size='small' aria-label='resend' title='Resend invitation'
                  data-testid={`p2pResendInvitee-${invitee.id}`} onClick={() => { onResend(invitee.id) }}
                >
                  <ForwardToInboxIcon fontSize='small' />
                </IconButton>}
              <IconButton
                size='small' aria-label='revoke' title='Remove invitation'
                data-testid={`p2pRevokeInvitee-${invitee.id}`} onClick={() => { onRevoke(invitee.id) }}
              >
                <DeleteOutlineIcon fontSize='small' />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
)
